import {
  CREATE_FLEETS_API,
  DELETE_FLEETS_API,
  GET_ALL_FLEETS_API,
  GET_FLEET_DETAIL_API,
  GET_FLEET_TREE_ADMIN_API,
  GET_FLEET_TREE_API,
  SEARCH_FLEETS_API,
  UPDATE_FLEETS_API
} from '~/constants/APIs'
import {
  FleetDetailType,
  IFleetForm,
  IFleetSearchForm,
  IFleetSearchResponse,
  IFleetTreeData
} from '~/models'
import axiosClient from './axiosClient'

export const fleetApis = {
  getAllFleets: () => axiosClient.get(GET_ALL_FLEETS_API) as unknown as FleetDetailType[],

  searchFleets: (data: IFleetSearchForm) => {
    return axiosClient.get(SEARCH_FLEETS_API, {
      params: { ...data, fleetId: data.fleetId !== '' ? data.fleetId : null }
    }) as unknown as IFleetSearchResponse
  },

  createFleet: (data: IFleetForm) => axiosClient.post(CREATE_FLEETS_API, data),

  updateFleet: (data: IFleetForm) => axiosClient.put(UPDATE_FLEETS_API + data.id, data),

  deleteFleet: (data: any) => axiosClient.delete(DELETE_FLEETS_API, { data }),

  getFleetDetail: (fleetId: string) =>
    axiosClient.get(GET_FLEET_DETAIL_API + fleetId) as unknown as FleetDetailType,

  getFleetTree: (fleetId?: string) =>
    axiosClient.get(GET_FLEET_TREE_API, {
      params: { fleetId }
    }) as unknown as IFleetTreeData,

  // get fleet tree in user page to get all fleets, only admin role can call it
  getFleetTreeAdmin: (fleetId?: string) =>
    axiosClient.get(GET_FLEET_TREE_ADMIN_API, {
      params: { fleetId }
    }) as unknown as IFleetTreeData
}
